import { render, staticRenderFns } from "./discountSet.vue?vue&type=template&id=0995383d&scoped=true&"
import script from "./discountSet.vue?vue&type=script&lang=js&"
export * from "./discountSet.vue?vue&type=script&lang=js&"
import style0 from "./discountSet.vue?vue&type=style&index=0&id=0995383d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0995383d",
  null
  
)

export default component.exports